// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../imgs/fundoEsq1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../imgs/LogoRotate.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loginpage{
    flex-direction: row;
    background-color: var(--white-color);
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    
}


.imageEsquerda{
    position: sticky;
    width: 60%;
    left: 5%;
    min-height: 90vh;
    border-radius: 15px;

}
.logoEsq{
    width: 80%;
    aspect-ratio: 2/1;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    transform: rotateY(0deg);
    -webkit-transform-origin-y: 580px;
    -webkit-transform-origin-z: 100px;
    animation: rotateLogo 2s ease forwards;
    display: flex;
    flex-direction: column;
    filter: drop-shadow(0px 0px 0px var(--white-color));
}


.loginContainer{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 400px;
    aspect-ratio: 2/1;
    padding: 5rem 2rem;
    margin: 0 auto;
    background-color: var(--white-color);
    border-radius: 15px;
}


.inputLogin {
    background-color: var(--white-color);
    width: 90%;
    margin-bottom: 3%;
    color: #000000;
    font-size: 20px;
    border-radius: 7px;
    padding: 10px;
    border: 1.5px solid #dededf;
}

.inputLogin:focus{
    border-color: rgba(120, 100, 234, 0.4);
    background-color: #fff;
    box-shadow: 0 0 0 4px #8164ea1a;
    outline: none;
}


.styleTextBtn{
    font-family: 'FanwoodText-Regular';
    color: var(--white-color);
    font-size: 20px;
    
}

.styleButton{
    width: 60%;
    height: 45px;
    background-color: #000000; 
    margin: 10px 3% 0 3%; 
    padding: 0 0;
    border-radius: 5px;
    text-align: center;
    line-height: 200%;
}

.loginESenhaV{
    display: flex;
    margin: 35px 0 5px 0;
    flex-direction : row; 
    width: 90%; 
    align-items: center;
    justify-content: flex-start
}
.imageLogineSenha{
    height:50px; 
    width: 50px;
    background-size: contain
}
.logoBabita{
    width:55%;
    background-size:contain;
    aspect-ratio: 25/8;
    height: fit-content;
}
.beatyFont{
    font-family: 'DancingScript-Regular';
    font-size: 60px;
    color: #000000;
    text-align: center;
    
}
.subTitle{
    margin: 2% 0;
}


@media(max-width: 1400px){
    .loginContainer{
        height: 60vh;
        width: 25vw;
        padding: 5% 2%;
    }

    .logoBabita {
        width: 44%;
    }

    .subTitle {
        margin: 0% 0;
        font-size: 3em;
    }

    .loginESenhaV {
        margin: 0% 0 5px 0;
    }

    .inputLogin {
        padding: 7px;
    }
}


@media(max-width: 767px){
    .loginContainer{
        width: 74%;
        /* height: 50%; */
        padding: 5rem 2rem;
    }
    .imageEsquerda{
        display: none;
    }
    .logoBabita{
        width: 80%;
    }
    .subTitle{
        margin: 2% 0;
    }
}


@media(max-width: 900px){
    
    .imageEsquerda{
        display: none;
    }
    .loginpage{
        background-size: cover;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});;
    }
}


@keyframes rotateLogo {
    from{
        transform: rotateY(200deg);
    }
    to{
        transform: rotateY(360deg);
        filter: drop-shadow(0px 0px 4px var(--white-color)7a) drop-shadow(0px 0px 11px var(--white-color)7a);
    }
}

/* ===== Ajuste mobile (app VendedorasAndroid / WebView) — login usável no celular =====
   O layout base é desktop (card height:60vh + padding:5rem + título 60px) e estourava
   no celular, cortando o botão Login. Aqui: card de altura automática, centralizado. */
@media (max-width: 767px) {
  .loginpage {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 16px 0 28px;
  }
  .imageEsquerda { display: none !important; }
  .loginContainer {
    width: 90%;
    max-width: 430px;
    height: auto;
    aspect-ratio: auto;
    min-height: 0;
    padding: 1.6rem 1.2rem;
    margin: auto;
  }
  .logoBabita { width: 70%; }
  .beatyFont.subTitle { font-size: 34px; margin: 6px 0; }
  .loginESenhaV { margin: 16px 0 5px 0; }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/login.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,oCAAoC;IACpC,yDAA8C;IAC9C,sBAAsB;;AAE1B;;;AAGA;IACI,gBAAgB;IAChB,UAAU;IACV,QAAQ;IACR,gBAAgB;IAChB,mBAAmB;;AAEvB;AACA;IACI,UAAU;IACV,iBAAiB;IACjB,yDAA+C;IAC/C,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;IACxB,iCAAiC;IACjC,iCAAiC;IACjC,sCAAsC;IACtC,aAAa;IACb,sBAAsB;IACtB,mDAAmD;AACvD;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,oCAAoC;IACpC,mBAAmB;AACvB;;;AAGA;IACI,oCAAoC;IACpC,UAAU;IACV,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;IACtC,sBAAsB;IAEtB,+BAA+B;IAC/B,aAAa;AACjB;;;AAGA;IACI,kCAAkC;IAClC,yBAAyB;IACzB,eAAe;;AAEnB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,oBAAoB;IACpB,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,oBAAoB;IACpB,UAAU;IACV,mBAAmB;IACnB;AACJ;AACA;IACI,WAAW;IACX,WAAW;IACX;AACJ;AACA;IACI,SAAS;IACT,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,oCAAoC;IACpC,eAAe;IACf,cAAc;IACd,kBAAkB;;AAEtB;AACA;IACI,YAAY;AAChB;;;AAGA;IACI;QACI,YAAY;QACZ,WAAW;QACX,cAAc;IAClB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,cAAc;IAClB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;AACJ;;;AAGA;IACI;QACI,UAAU;QACV,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,aAAa;IACjB;IACA;QACI,UAAU;IACd;IACA;QACI,YAAY;IAChB;AACJ;;;AAGA;;IAEI;QACI,aAAa;IACjB;IACA;QACI,sBAAsB;QACtB,yDAA8C;IAClD;AACJ;;;AAGA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,0BAA0B;QAC1B,oGAAoG;IACxG;AACJ;;AAEA;;uFAEuF;AACvF;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;EACtB;EACA,iBAAiB,wBAAwB,EAAE;EAC3C;IACE,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;EACd;EACA,cAAc,UAAU,EAAE;EAC1B,sBAAsB,eAAe,EAAE,aAAa,EAAE;EACtD,gBAAgB,oBAAoB,EAAE;AACxC","sourcesContent":[".loginpage{\r\n    flex-direction: row;\r\n    background-color: var(--white-color);\r\n    background-image: url('../imgs/fundoEsq1.jpg');\r\n    background-size: cover;\r\n    \r\n}\r\n\r\n\r\n.imageEsquerda{\r\n    position: sticky;\r\n    width: 60%;\r\n    left: 5%;\r\n    min-height: 90vh;\r\n    border-radius: 15px;\r\n\r\n}\r\n.logoEsq{\r\n    width: 80%;\r\n    aspect-ratio: 2/1;\r\n    background-image: url('../imgs/LogoRotate.svg');\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n    transform: rotateY(0deg);\r\n    -webkit-transform-origin-y: 580px;\r\n    -webkit-transform-origin-z: 100px;\r\n    animation: rotateLogo 2s ease forwards;\r\n    display: flex;\r\n    flex-direction: column;\r\n    filter: drop-shadow(0px 0px 0px var(--white-color));\r\n}\r\n\r\n\r\n.loginContainer{\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    width: 400px;\r\n    aspect-ratio: 2/1;\r\n    padding: 5rem 2rem;\r\n    margin: 0 auto;\r\n    background-color: var(--white-color);\r\n    border-radius: 15px;\r\n}\r\n\r\n\r\n.inputLogin {\r\n    background-color: var(--white-color);\r\n    width: 90%;\r\n    margin-bottom: 3%;\r\n    color: #000000;\r\n    font-size: 20px;\r\n    border-radius: 7px;\r\n    padding: 10px;\r\n    border: 1.5px solid #dededf;\r\n}\r\n\r\n.inputLogin:focus{\r\n    border-color: rgba(120, 100, 234, 0.4);\r\n    background-color: #fff;\r\n    -webkit-box-shadow: 0 0 0 4px #6466ea1a;\r\n    box-shadow: 0 0 0 4px #8164ea1a;\r\n    outline: none;\r\n}\r\n\r\n\r\n.styleTextBtn{\r\n    font-family: 'FanwoodText-Regular';\r\n    color: var(--white-color);\r\n    font-size: 20px;\r\n    \r\n}\r\n\r\n.styleButton{\r\n    width: 60%;\r\n    height: 45px;\r\n    background-color: #000000; \r\n    margin: 10px 3% 0 3%; \r\n    padding: 0 0;\r\n    border-radius: 5px;\r\n    text-align: center;\r\n    line-height: 200%;\r\n}\r\n\r\n.loginESenhaV{\r\n    display: flex;\r\n    margin: 35px 0 5px 0;\r\n    flex-direction : row; \r\n    width: 90%; \r\n    align-items: center;\r\n    justify-content: flex-start\r\n}\r\n.imageLogineSenha{\r\n    height:50px; \r\n    width: 50px;\r\n    background-size: contain\r\n}\r\n.logoBabita{\r\n    width:55%;\r\n    background-size:contain;\r\n    aspect-ratio: 25/8;\r\n    height: fit-content;\r\n}\r\n.beatyFont{\r\n    font-family: 'DancingScript-Regular';\r\n    font-size: 60px;\r\n    color: #000000;\r\n    text-align: center;\r\n    \r\n}\r\n.subTitle{\r\n    margin: 2% 0;\r\n}\r\n\r\n\r\n@media(max-width: 1400px){\r\n    .loginContainer{\r\n        height: 60vh;\r\n        width: 25vw;\r\n        padding: 5% 2%;\r\n    }\r\n\r\n    .logoBabita {\r\n        width: 44%;\r\n    }\r\n\r\n    .subTitle {\r\n        margin: 0% 0;\r\n        font-size: 3em;\r\n    }\r\n\r\n    .loginESenhaV {\r\n        margin: 0% 0 5px 0;\r\n    }\r\n\r\n    .inputLogin {\r\n        padding: 7px;\r\n    }\r\n}\r\n\r\n\r\n@media(max-width: 767px){\r\n    .loginContainer{\r\n        width: 74%;\r\n        /* height: 50%; */\r\n        padding: 5rem 2rem;\r\n    }\r\n    .imageEsquerda{\r\n        display: none;\r\n    }\r\n    .logoBabita{\r\n        width: 80%;\r\n    }\r\n    .subTitle{\r\n        margin: 2% 0;\r\n    }\r\n}\r\n\r\n\r\n@media(max-width: 900px){\r\n    \r\n    .imageEsquerda{\r\n        display: none;\r\n    }\r\n    .loginpage{\r\n        background-size: cover;\r\n        background-image: url('../imgs/fundoEsq1.jpg');;\r\n    }\r\n}\r\n\r\n\r\n@keyframes rotateLogo {\r\n    from{\r\n        transform: rotateY(200deg);\r\n    }\r\n    to{\r\n        transform: rotateY(360deg);\r\n        filter: drop-shadow(0px 0px 4px var(--white-color)7a) drop-shadow(0px 0px 11px var(--white-color)7a);\r\n    }\r\n}\n\n/* ===== Ajuste mobile (app VendedorasAndroid / WebView) — login usável no celular =====\n   O layout base é desktop (card height:60vh + padding:5rem + título 60px) e estourava\n   no celular, cortando o botão Login. Aqui: card de altura automática, centralizado. */\n@media (max-width: 767px) {\n  .loginpage {\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 16px 0 28px;\n  }\n  .imageEsquerda { display: none !important; }\n  .loginContainer {\n    width: 90%;\n    max-width: 430px;\n    height: auto;\n    aspect-ratio: auto;\n    min-height: 0;\n    padding: 1.6rem 1.2rem;\n    margin: auto;\n  }\n  .logoBabita { width: 70%; }\n  .beatyFont.subTitle { font-size: 34px; margin: 6px 0; }\n  .loginESenhaV { margin: 16px 0 5px 0; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
